import * as React from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment-timezone';
import { useSelector, useDispatch } from 'react-redux';
import { ApiKeyContext } from 'contexts/ApiKeyContext';

import { fetchProductInstances } from 'ducks/client/productInstances';
import { ReduxState } from 'ducks';

export const useLastProductInstanceId = (): string | null => {
  const { i18n } = useTranslation();
  const dispatch = useDispatch();
  const [lastProductInstanceId, setLastProductInstanceId] = React.useState<string | null>(null);
  const { apiKey } = React.useContext(ApiKeyContext);

  const product = useSelector((state: ReduxState) => state.server.product.product);

  const productInstances = useSelector((state: ReduxState) => state.productInstances.all);

  React.useEffect(() => {
    if (product?.booking_widget_settings?.is_free_start_date_time) {
      dispatch(
        fetchProductInstances(
          apiKey,
          product.id,
          moment(product.recurrence[0].end_date_local).add(-1, 'd').format('YYYY-MM-DD'),
          moment(product.recurrence[0].end_date_local).add(1, 'd').format('YYYY-MM-DD'),
          i18n.language
        )
      );
    }
  }, [product]);

  React.useEffect(() => {
    if (
      product?.booking_widget_settings?.is_free_start_date_time &&
      (productInstances ?? []).length > 0
    ) {
      const last = productInstances[productInstances.length - 1];
      setLastProductInstanceId(last.id);
    }
  }, [product, productInstances]);

  return lastProductInstanceId;
};
